module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"upsell-banner\"> <button class=\"upsell-mtv-close\"> <svg aria-hidden=\"true\" data-display-name=\"Icon\" focusable=\"false\" preserveAspectRatio=\"xMinYMin\" xmlns=\"http://www.w3.org/2000/svg\" role=\"button\" class=\"efnjrt41 css-lfee4p-Svg-StyledCloseIcon e1t3qibb0\" viewBox=\"0 0 22 22\" data-icon-name=\"Close\"><path d=\"M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zM7.404 6.178a.875.875 0 00-1.148 1.316L9.763 11l-3.507 3.506-.078.09a.875.875 0 001.226 1.226l.09-.078L11 12.237l3.506 3.507.09.078a.875.875 0 001.148-1.316L12.237 11l3.507-3.506.078-.09a.875.875 0 00-1.226-1.226l-.09.078L11 9.763 7.494 6.256l-.09-.078z\"></path></svg> </button> <div class=\"upsell-banner-content\"> <div class=\"upsell-banner-content-wrapper\"> <img src=\"<%= showLogo.url %>\" alt=\"\" class=\"upsell-mtv-logo\"> <h1><%= headerText %></h1> <h2><%= subheaderText %></h2> </div> </div> </div> <div class=\"upsell-info\"> <%- copy %> <a href=\"<%= promoResourceLinks[0].url %>\" target=\"_blank\" class=\"upsell-link\"><%= promoResourceLinks[0].copy %></a> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="upsell-banner"> <button class="upsell-mtv-close"> <svg aria-hidden="true" data-display-name="Icon" focusable="false" preserveAspectRatio="xMinYMin" xmlns="http://www.w3.org/2000/svg" role="button" class="efnjrt41 css-lfee4p-Svg-StyledCloseIcon e1t3qibb0" viewBox="0 0 22 22" data-icon-name="Close"><path d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zM7.404 6.178a.875.875 0 00-1.148 1.316L9.763 11l-3.507 3.506-.078.09a.875.875 0 001.226 1.226l.09-.078L11 12.237l3.506 3.507.09.078a.875.875 0 001.148-1.316L12.237 11l3.507-3.506.078-.09a.875.875 0 00-1.226-1.226l-.09.078L11 9.763 7.494 6.256l-.09-.078z"></path></svg> </button> <div class="upsell-banner-content"> <div class="upsell-banner-content-wrapper"> <img src="', escape((__stack.lineno=1,  showLogo.url )), '" alt="" class="upsell-mtv-logo"> <h1>', escape((__stack.lineno=1,  headerText )), '</h1> <h2>', escape((__stack.lineno=1,  subheaderText )), '</h2> </div> </div> </div> <div class="upsell-info"> ', (__stack.lineno=1,  copy ), ' <a href="', escape((__stack.lineno=1,  promoResourceLinks[0].url )), '" target="_blank" class="upsell-link">', escape((__stack.lineno=1,  promoResourceLinks[0].copy )), '</a> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/upsell.ejs
// module id = 254
// module chunks = 0